var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgQuickbooksMark = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "30px",
    viewBox: "0 0 34 30",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Shape")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HS-home-page-refresh-2020_test",
    transform: "translate(-75.000000, -6381.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(44.000000, 6348.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "quickbooks-dde28103ae7b25d95fbb767f97a72b57658119f51adef6635472b33e8d957596",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5204,14.4984 C11.2908,14.4984 7.0524,18.75 7.0524,23.9988 C7.0524,29.2464 11.2908,33.4992 16.5204,33.4992 L17.4228,33.4992 L17.4228,30.1512 L16.5204,30.1512 C13.0944,30.1512 10.3884,27.3468 10.3884,23.9988 C10.38574,20.6075882 13.1291998,17.8544646 16.5204,17.8452 L19.4964,17.8452 L19.4964,38.2044 L22.9224,38.2044 L22.9224,14.4984 L16.5204,14.4984 Z M31.4796,33.6984 C36.7092,33.6984 40.9476,29.4456 40.9476,24.198 C40.9476,18.9492 36.7092,14.6964 31.4796,14.6964 L30.5772,14.6964 L30.5772,18.0444 L31.4796,18.0444 C34.9056,18.0444 37.6116,20.85 37.6116,24.198 C37.6135979,27.5887435 34.8703314,30.3411363 31.4796,30.3504 L28.5036,30.3504 L28.5036,9.9924 L25.0776,9.9924 L25.0776,33.6984 L31.4796,33.6984 Z",
    id: "Shape"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuickbooksMark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/quickbooks-mark.a03bad9b.svg";
export { ForwardRef as ReactComponent };